import { Injectable } from '@angular/core'
import {ActiveCartFacade, MultiCartFacade} from '@spartacus/cart/base/root'
import { Command, CommandService, CommandStrategy, EventService } from '@spartacus/core'
import { Order, OrderFacade, OrderPlacedEvent } from '@spartacus/order/root'
import {BehaviorSubject, Observable} from 'rxjs'
import { map, tap } from 'rxjs/operators'
import {EbCart} from "../../cart/interface/eb-cart.interface";
import { EbCheckoutAdapter } from '../services/connectors/eb-checkout.adapter'
import { EbCompleteDeliveryAdapter } from '../services/connectors/eb-complete-delivery.adapter'
import { EbRequestedShippingDateAdapter } from '../services/connectors/eb-requested-shipping-date.adapter'

@Injectable({ providedIn: 'root' })
export class EbCheckoutCommandService {
  isRequestedShippingDaySet$ =   new BehaviorSubject(false);

  constructor(
    protected commandService: CommandService,
    protected checkoutAdapter: EbCheckoutAdapter,
    protected eventService: EventService,
    protected requestedShippingDateAdapter: EbRequestedShippingDateAdapter,
    protected completeDeliveryAdapter: EbCompleteDeliveryAdapter,
    protected orderService: OrderFacade,
    protected multiCartFacade: MultiCartFacade,
    protected activeCartFacade: ActiveCartFacade
  ) {}

  protected placeOrderCommand: Command<
    {
      userId: string
      cartId: string
      termsAndConditions: boolean
      exportControlProvisions: boolean
    },
    Order
  > = this.commandService.create(
    payload => {
      return this.checkoutAdapter
        .placeOrder(
          payload.userId,
          payload.cartId,
          payload.termsAndConditions,
          payload.exportControlProvisions
        )
        .pipe(
          tap(order => {
            this.eventService.dispatch(
              {
                userId: payload.userId,
                cartId: payload.cartId,
                cartCode: payload.cartId,
                order
              },
              OrderPlacedEvent
            )
            this.orderService.setPlacedOrder(order)
          })
        )
    },
    {
      strategy: CommandStrategy.CancelPrevious
    }
  )
  placeOrder(
    userId: string,
    cartId: string,
    termsAndConditions: boolean,
    exportControlProvisions: boolean
  ): Observable<Order> {
    return this.placeOrderCommand.execute({
      userId,
      cartId,
      termsAndConditions,
      exportControlProvisions
    })
  }

  public setRequestedShippingDateCommand: Command<{
    cartId: string
    userId: string
    date: string
    isValidationNeeded: boolean
    changedByCustomer: boolean
    recalculateCart: boolean
  }> = this.commandService.create(
    payload => {
      return this.requestedShippingDateAdapter
        .setRequestedShippingDate(
          payload.cartId,
          payload.userId,
          payload.date,
          payload.isValidationNeeded,
          payload.changedByCustomer,
          payload.recalculateCart
        ) .pipe(
          tap(() =>{
            this.cart$().subscribe(()=> {
              this.isRequestedShippingDaySet$.next(true);
            })
          }
          )
        )
    },
    {
      strategy: CommandStrategy.CancelPrevious
    }
  )
  cart$(): Observable<EbCart> {
    return this.activeCartFacade.getActive()
  }
  setRequestedShippingDate(
    cartId: string,
    userId: string,
    date: string,
    isValidationNeeded: boolean,
    changedByCustomer: boolean,
    recalculateCart: boolean
  ): void {
    this.isRequestedShippingDaySet$.next(false);
    this.setRequestedShippingDateCommand.execute({
      cartId,
      userId,
      date,
      isValidationNeeded,
      changedByCustomer,
      recalculateCart
    })
  }
  setCompleteDeliveryCommand: Command<{
    cartId: string
    userId: string
    completedDelivery: boolean
  }> = this.commandService.create(payload => {
    return this.completeDeliveryAdapter
      .setDeliveryModeType(payload.cartId, payload.userId, payload.completedDelivery)
      .pipe(
        map(() =>
          this.multiCartFacade.loadCart({
            cartId: payload.cartId,
            userId: payload.userId
          })
        )
      )
  })
}
